// extracted by mini-css-extract-plugin
module.exports = {"wrPreview":"WrPreview_wrPreview__1UIFv","particles":"WrPreview_particles__1GvoB"};